import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

// example payload
// {
//   "input": {
//     "groupName": "GroupName",
//     "permissions": [{
//       "id": "jumbo-backoffice-managed-role:operaciones",
//       "accesses": ["orders-shipment:update"]
//     },
//     {
//       "id": "jumbo-backoffice-managed-role:auditoria",
//       "accesses": ["orders-audit:read"]
//     }]
//   }
// }

const CREATE_GROUP = gql`mutation createGroup($input: ABMGroupInput) {
  createGroup(input: $input) {
    id
    description
    permissions {
      name
      id
      accesses
    }
  }
}
`
const UpdatePickers = ({ children, ...props }) => {
  return (
    <MutationManager mutation={CREATE_GROUP} refetchQueries={['getGroups', 'getUserSessionInfo']}>
      {({ data, loading, client, updateFn }) => children({ updateFn, client, loading, ...props })}
    </MutationManager>
  )
}

UpdatePickers.propTypes = {
  children: PropTypes.any
}

export default UpdatePickers
